<div
  class="tab-pane fade flex-even active show"
  id="sales"
  role="tabpanel"
  aria-labelledby="sales-tab"
  >
  @if (contractBase$ | async; as contractBase) {
    <div
      class="d-flex flex-column h-100"
      >
      <div class="row mt-2">
        <div class="col-12 col-md">
          <div class="form-group-title my-1" translate>
            CONTRACT_FIELDSET_FEES_AND_CHARGES
          </div>
          <div class="form-group row">
            <label class="col-4 col-form-label-sm" translate
              >CONTRACT_LBL_MONTHLY_FEE</label
              >
              <div class="col">
                <span class="form-control-plaintext form-control-sm">
                  {{ contractBase.monthlyFee | currency : "EUR" }}
                </span>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-4 col-form-label-sm" translate
                >CONTRACT_LBL_ANNUAL_FEE</label
                >
                <div class="col">
                  <span class="form-control-plaintext form-control-sm">
                    {{ contractBase.annualFee ?? 0 | currency : "EUR" }}
                  </span>
                </div>
              </div>
              <div class="form-group row">
                <label class="col-4 col-form-label-sm" translate
                  >CONTRACT_LBL_EXCLUDED_TAX_ANNUAL_FEE</label
                  >
                  <div class="col">
                    <span class="form-control-plaintext form-control-sm">
                      {{ contractBase.excludedTaxAnnualFee ?? 0 | currency : "EUR" }}
                    </span>
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-4 col-form-label-sm" translate
                    >CONTRACT_LBL_TAX_RATE</label
                    >
                    <div class="col">
                      <span class="form-control-plaintext form-control-sm">
                        {{ contractBase.taxRate ?? 0 }} %
                      </span>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label class="col-4 col-form-label-sm" translate
                      >CONTRACT_LBL_COMMISSION_RATE</label
                      >
                      <div class="col">
                        <span class="form-control-plaintext form-control-sm">
                          {{
                          contractBase.commissionRate === undefined ||
                          contractBase.commissionRate == null
                          ? "-"
                          : contractBase.commissionRate + " %"
                          }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <!--      Status-->
                  <div class="col">
                    <!--        <div class="form-group-title my-1" translate>-->
                    <!--          CONTRACT_FIELDSET_VALIDATION-->
                  <!--        </div>-->
                  <!--        <div class="form-group row">-->
                  <!--          <label class="col-4 col-form-label-sm" translate-->
                <!--          >CONTRACT_LBL_VALIDATION_DATE</label-->
                <!--          >-->
                <!--          <div class="col">-->
                <!--            <input-->
                <!--              class="form-control-plaintext form-control-sm"-->
                <!--              type="text"-->
                <!--              readonly-->
<!--              [value]="-->
<!--                contractBase.validationDate-->
<!--                  ? (contractBase.validationDate | date : 'dd/MM/yyyy')-->
<!--                  : '-'-->
<!--              "-->
<!--            />-->
<!--          </div>-->
<!--        </div>-->

<!--        <div class="form-group row">-->
<!--          <label class="col-4 col-form-label-sm" translate-->
<!--          >CONTRACT_LBL_APPROVER</label-->
<!--          >-->
<!--          <div class="col">-->
<!--            <input-->
<!--              class="form-control-plaintext form-control-sm"-->
<!--              readonly-->
<!--              value="{{ contractBase.approverContactName }}"-->
<!--            />-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="form-group row">-->
<!--          <label class="col-4 col-form-label-sm" translate-->
<!--          >CONTRACT_LBL_DOCUMENTS_RECEIVED_DATE</label-->
<!--          >-->
<!--          <div class="col">-->
<!--            <input-->
<!--              class="form-control-plaintext form-control-sm"-->
<!--              type="text"-->
<!--              readonly-->
<!--              [value]="-->
<!--                contractBase.documentsReceivedDate-->
<!--                  ? (contractBase.documentsReceivedDate | date : 'dd/MM/yyyy')-->
<!--                  : '-'-->
<!--              "-->
<!--            />-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="form-group row">-->
<!--          <label class="col-4 col-form-label-sm" translate-->
<!--          >CONTRACT_LBL_DOCUMENTS_SENT_DATE</label-->
<!--          >-->
<!--          <div class="col">-->
<!--            <input-->
<!--              class="form-control-plaintext form-control-sm"-->
<!--              type="text"-->
<!--              readonly-->
<!--              [value]="-->
<!--                contractBase.documentsSentDate-->
<!--                  ? (contractBase.documentsSentDate | date : 'dd/MM/yyyy')-->
<!--                  : '-'-->
<!--              "-->
<!--            />-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="form-group row">-->
<!--          <label class="col-4 col-form-label-sm" translate-->
<!--          >CONTRACT_LBL_REGULARIZATION_DATE</label-->
<!--          >-->
<!--          <div class="col">-->
<!--            <input-->
<!--              class="form-control-plaintext form-control-sm"-->
<!--              type="text"-->
<!--              readonly-->
<!--              [value]="-->
<!--                contractBase.regularizationDate-->
<!--                  ? (contractBase.regularizationDate | date : 'dd/MM/yyyy')-->
<!--                  : '-'-->
<!--              "-->
<!--            />-->
<!--          </div>-->
<!--        </div>-->
      </div>
    </div>

    <div class="row mt-2">
      <div class="col-12 col-md"></div>
<!--      Status-->
      <div class="col">
<!--        <div class="form-group-title my-1" translate>-->
<!--          CONTRACT_FIELDSET_END_DATE-->
<!--        </div>-->
<!--        <div class="form-group row">-->
<!--          <label class="col-4 col-form-label-sm" translate-->
<!--            >CONTRACT_LBL_EXPIRY_DATE</label-->
<!--          >-->
<!--          <div class="col">-->
<!--            <input-->
<!--              class="form-control-plaintext form-control-sm"-->
<!--              type="text"-->
<!--              readonly-->
<!--              value="1er janvier"-->
<!--            />-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="form-group row">-->
<!--          <label class="col-4 col-form-label-sm" translate-->
<!--            >CONTRACT_LBL_TERMINATION_DATE</label-->
<!--          >-->
<!--          <div class="col">-->
<!--            <input-->
<!--              class="form-control-plaintext form-control-sm"-->
<!--              type="text"-->
<!--              readonly-->
<!--              [value]="-->
<!--                contractBase.terminationDate-->
<!--                  ? (contractBase.terminationDate | date : 'dd/MM/yyyy')-->
<!--                  : '-'-->
<!--              "-->
<!--            />-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="form-group row">-->
<!--          <label class="col-4 col-form-label-sm" translate-->
<!--            >CONTRACT_LBL_TERMINATION_REASON</label-->
<!--          >-->
<!--          <div class="col">-->
<!--            <input-->
<!--              class="form-control-plaintext form-control-sm"-->
<!--              type="text"-->
<!--              readonly-->
<!--              value="{{ contractBase.terminationReasonName }}"-->
<!--            />-->
<!--          </div>-->
<!--        </div>-->
      </div>
    </div>
  </div>
}
</div>
